(function () {
  var root = document.documentElement;

  // 1. scroll padding
  function setVar(name, px) {
    root.style.setProperty(name, Math.max(0, Math.round(px)) + 'px');
  }
  function headerHeight() {
    var header = document.querySelector('.shopify-section-header-sticky, .section-header');
    if (!header) return 0;
    var pos = getComputedStyle(header).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return header.getBoundingClientRect().height;
  }
  function barHeight() {
    var bar = document.querySelector('.twi-sticky');
    if (!bar || !bar.classList.contains('is-visible')) return 0;
    return bar.getBoundingClientRect().height;
  }
  var queued = false;
  function update() {
    queued = false;
    setVar('--twi-sticky-top', headerHeight());
    setVar('--twi-sticky-bottom', barHeight());
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  update();
  window.addEventListener('resize', queue);
  window.addEventListener('scroll', queue, { passive: true });
  if (window.ResizeObserver) {
    var header = document.querySelector('.shopify-section-header-sticky, .section-header');
    if (header) new ResizeObserver(queue).observe(header);
  }
  var bar = document.querySelector('.twi-sticky');
  if (bar && window.MutationObserver) {
    new MutationObserver(queue).observe(bar, { attributes: true, attributeFilter: ['class'] });
  }

  if (!window.MutationObserver) return;

  // 2. skip link first
  var skip = document.querySelector('body > a.skip-to-content-link');
  if (skip) {
    var moves = 0;
    var keepFirst = function () {
      if (document.body.firstElementChild === skip) return;
      if (++moves > 5) return skipObserver.disconnect();
      document.body.insertBefore(skip, document.body.firstChild);
    };
    var skipObserver = new MutationObserver(keepFirst);
    skipObserver.observe(document.body, { childList: true });
    keepFirst();
  }

  // 3. Judge.me star images out of the tab order
  var STARS = '[class*="jdgm"][role="img"][tabindex="0"]';
  function untab(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches(STARS)) scope.removeAttribute('tabindex');
    scope.querySelectorAll(STARS).forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }
  untab(document.body);
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'attributes') untab(r.target);
      else for (var j = 0; j < r.addedNodes.length; j++) if (r.addedNodes[j].nodeType === 1) untab(r.addedNodes[j]);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex'] });
})();

(function () {
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.jdgm-prev-badge, a[href*="#judgeme"]') : null;
    if (!t) return;
    var w = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
    if (!w) return;
    e.preventDefault();
    e.stopPropagation();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    w.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    // Sections further down render lazily and change height mid-scroll, so a smooth scroll can stop short.
    // When it settles, land exactly (instant, only if it is off by more than a few px).
    var settle = function () {
      var want = (parseFloat(getComputedStyle(w).scrollMarginTop) || 0) + (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0);
      if (Math.abs(w.getBoundingClientRect().top - want) > 4) w.scrollIntoView({ behavior: 'auto', block: 'start' });
    };
    if ('onscrollend' in window) window.addEventListener('scrollend', settle, { once: true }); else setTimeout(settle, 900);
  }, true);
})();
